import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps } from 'react';
import { IconDeprecated } from '../../misc/IconDeprecated/IconDeprecated';
import { SyncIcon } from '../../synchronization/SyncIcon/SyncIcon';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import { BreadcrumbBar } from '../BreadcrumbBar/BreadcrumbBar';
import styles from './Navbar.module.css';
export type NavbarProps = ComponentProps<'div'> & {
  onMenuIconClick: () => void;
  onSyncIconClick: () => void;
};
export const Navbar: FunctionComponent<NavbarProps> = React.memo(props => {
  const $ = _c(22);
  let onMenuIconClick;
  let onSyncIconClick;
  let t0;
  let t1;
  if ($[0] !== props) {
    const {
      className,
      onMenuIconClick: t2,
      onSyncIconClick: t3,
      ...remainingProps
    } = prepareProps({
      props,
      ignoreChildren: true
    });
    onMenuIconClick = t2;
    onSyncIconClick = t3;
    t0 = remainingProps;
    t1 = classes(className, styles.placeholder);
    $[0] = props;
    $[1] = onMenuIconClick;
    $[2] = onSyncIconClick;
    $[3] = t0;
    $[4] = t1;
  } else {
    onMenuIconClick = $[1];
    onSyncIconClick = $[2];
    t0 = $[3];
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classes(styles.nav);
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconDeprecated name="bars" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onMenuIconClick) {
    t4 = <div className={styles.menuIconWrapper} onClick={onMenuIconClick} data-testid="Navbar.MenuIconWrapper">{t3}</div>;
    $[7] = onMenuIconClick;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SyncIcon />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onSyncIconClick) {
    t6 = <div className={styles.rightIconsWrapper} onClick={onSyncIconClick} data-testid="Navbar.SyncIconWrapper">{t5}</div>;
    $[10] = onSyncIconClick;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <nav className={t2}>{t4}{t6}</nav>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <BreadcrumbBar />;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7) {
    t9 = <div className={styles.fixedContent}>{t7}{t8}</div>;
    $[16] = t7;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t0 || $[19] !== t1 || $[20] !== t9) {
    t10 = <div {...t0} className={t1}>{t9}</div>;
    $[18] = t0;
    $[19] = t1;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
});